import {Plain} from '../../../../../shared/model/plain.type.model';
import {buildEmptyCondition, Condition} from './condition.model';
import {CONDITION_TYPE} from './condition.type.model';
import {OPERATOR_LOGICAL} from './operator.logical.model';

export class Group {
    public operator: OPERATOR_LOGICAL;
    public conditions: Condition[];

    constructor(data: Plain<Group>) {
        this.operator = data.operator ?? OPERATOR_LOGICAL.AND;
        // Condition est une simple structure de données : pas de réinstanciation nécessaire.
        this.conditions = data.conditions ?? [];
    }
}

/**
 * Groupe tel qu'il s'ouvre : une seule condition, vide, à remplir. Jamais zéro — un groupe sans
 * condition ne se distinguerait pas d'un groupe absent, et n'offrirait rien à saisir.
 */
export const buildEmptyGroup = (conditionType?: CONDITION_TYPE): Group =>
    new Group({operator: OPERATOR_LOGICAL.AND, conditions: [buildEmptyCondition(conditionType)]});
